import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { Component, inject, ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { SpinnerService } from './core/service/spinner.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter, :leave', [animate(100)]),
    ]),
  ],
})
export class AppComponent {
  title = 'Chevron';
  private readonly translate = inject(TranslateService);
  private readonly primeNg = inject(PrimeNG);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly router = inject(Router);

  isLoading = false;
  showTestingEnvironmentNotice = false;
  readonly isProd = environment.prod;
  private readonly spinner = inject(SpinnerService);

  ngOnInit() {
    document.documentElement.classList.remove('app-dark');
    document.documentElement.classList.remove('custom-dark');
    document.documentElement.style.colorScheme = 'light';

    this.spinner.isLoading.subscribe((isLoading) => {
      if (!isLoading) {
        //* Le ponemos un timeout para que se muestre la animación del leave
        setTimeout(() => {
          this.isLoading = isLoading;
          this.cdr.detectChanges();
        }, 200);
      } else {
        this.isLoading = isLoading;
        this.cdr.detectChanges();
      }
    });

    const idiomaGuardado = localStorage.getItem('idioma');
    const idioma = idiomaGuardado || navigator.language.split('-')[0] || 'es';

    const idiomasSoportados = ['es', 'en'];

    const idiomaFinal = idiomasSoportados.includes(idioma) ? idioma : 'es';

    this.setTranslate(idiomaFinal);

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (!this.isProd && event.urlAfterRedirects !== '/login' && sessionStorage.getItem('showTestingEnvironmentNotice') === 'true') {
          sessionStorage.removeItem('showTestingEnvironmentNotice');
          this.showTestingEnvironmentNotice = true;
        }
      });

    const a = `<b class="text-bold"></b>`;
  }

  closeTestingEnvironmentNotice() {
    this.showTestingEnvironmentNotice = false;
  }

  private setTranslate(lang: string) {
    this.translate.addLangs(['es', 'en']);
    this.translate.setDefaultLang('es');
    this.translate.use(lang);
    this.translate.get('primeng').subscribe((res) => {
      this.primeNg.setTranslation(res);
    });
  }
}
